import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridToolbar, GridValueGetterParams, GridColDef } from '@mui/x-data-grid-pro';

import { Comment } from 'app/model/comment';
export const CommentGrid: React.FunctionComponent<Omit<DataGridProProps<Comment>, 'columns'>> = ({ ...rest }) => (
    <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
        <DataGridPro
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
                toolbar: {
                    csvOptions: { disableToolbarButton: true },
                    printOptions: { disableToolbarButton: true },
                },
            }}
            {...rest}
            columns={commonColumns}
        />
    </Box>
);
const commonColumns: Array<GridColDef<Comment>> = [
    {
        field: 'owner',
        headerName: 'User',
        type: 'string',
        valueGetter: (params: GridValueGetterParams<Comment, Comment['owner']>) => params.value?.username,
        flex: 1,
    },
    {
        field: 'comment',
        headerName: 'Comment',
        type: 'string',
        flex: 1,
    },
    {
        field: 'addedOn',
        headerName: 'Added On',
        type: 'string',
        flex: 1,
    },
];
